
  (function () {
    const url = new URL(window.location.href);
    const hasUtm =
      url.searchParams.has('utm_source') ||
      url.searchParams.has('utm_medium') ||
      url.searchParams.has('utm_campaign') ||
      url.searchParams.has('utm_term') ||
      url.searchParams.has('utm_content');
    if (hasUtm) {
      const cleanUrl = url.pathname + url.hash;
      window.history.replaceState({}, document.title, cleanUrl);
    }
  })();
